<script lang="ts">var _a, _b, _c;
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import { t } from '../../../../js/i18n';
import { resolveUrl } from '../../../../js/url';
import { JanusSignonManagerToken } from "../../../../js/sso";
import { getFirstSourceStore, getTemplatedElementDataFromSource } from '../../utilities';
import { Readable } from 'svelte/store';
import { CardsDataSourceRegistration } from '../../common/CardsDataSourceRegistration';
import { onMount } from 'svelte';
import { getToken } from 'inversify-token';
import ROOT from '../../../../inversify.config';
export let element;
export let sources;
const signonManager = getToken(ROOT, JanusSignonManagerToken);
$: source = getFirstSourceStore($sources);
$: loggedOutUrl = ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.loggedOutUrl) || null;
$: loggedInUrl = ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.loggedInUrl) || null;
$: autoRedirectDelayMillis = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.autoRedirectDelayMillis) || 0;
onMount(() => {
    setTimeout(() => {
        // Run on next tick
        const signonStatus = signonManager.getStatus();
        let url = null;
        if (loggedOutUrl) {
            url = resolveUrl(loggedOutUrl);
        }
        if (signonStatus.loggedIn && loggedInUrl) {
            url = resolveUrl(loggedInUrl);
        }
        if (url) {
            setTimeout(() => {
                url.func();
            }, autoRedirectDelayMillis);
        }
    }, 0);
});
</script>